module.exports = __webpack_public_path__ + "img/PASTE.7cebb6b3.svg";